import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import SignatureCanvas from "react-signature-canvas";
import {FormattedMessage, injectIntl} from "react-intl";

import {
  setContractsList,
  setContractsValues,
  showContractSigning,
  showSignaturePad
} from "../../../actions/contractsActions";
import {renderErrorPopup} from "../../../api/api-popups";
import Analytics from "../../../analytics";
import {setReceiptSignature} from "../../../actions/printFunctions";
import {getSelectedContracts} from "./contractsFunctions";
import {getFieldNameWithoutRequired, getFieldValue} from "./contractsFieldsFunctions";

class SignaturePadPopup extends Component {

  constructor(props) {
    super(props);
    this.state = {
      custom: '',
    }
  }

  componentDidMount() {
    const {activeContract, contractsValues, signaturePadTag, receiptSignature} = this.props;
    if (this.props.step !== 3 && this.sigCanvas && signaturePadTag) {
      const {pageIndex, fieldIndex} = signaturePadTag;
      const values = activeContract && contractsValues ? contractsValues[activeContract.id] : {};
      if (values && values[pageIndex] && values[pageIndex][fieldIndex] && values[pageIndex][fieldIndex].value) {
        this.setSignatureImage(values[pageIndex][fieldIndex].value);
      } else if (signaturePadTag && signaturePadTag.isReceiptSign && receiptSignature) {
        this.setSignatureImage(receiptSignature);
      }
    }
  }

  setSignatureImage = (base64Image) => {
    // here we are not using native .fromDataURL() method, because it is resizing the image, if we want to use fromDataURL
    // then we need instead of .getTrimmedCanvas().toDataURL('image/png') use .toDataURL(), but it enlarges the image
    this.sigCanvas._sigPad._reset();
    const copy = document.createElement('canvas');
    copy.width = this.sigCanvas._canvas.width
    copy.height = this.sigCanvas._canvas.height;
    const image = new Image();
    image.src = base64Image;
    image.onload = () => {
      copy.getContext('2d').drawImage(image,
        copy.width / 2 - image.width / 2,
        copy.height / 2 - image.height / 2
      );
      this.sigCanvas.fromDataURL(copy.toDataURL('image/png'));
      this.sigCanvas._sigPad._isEmpty = false;
    };
  }

  isInformationFilled = () => {
    return this.sigCanvas && !this.sigCanvas.isEmpty();
  }

  postContractSignature = () => {
    if (!this.isInformationFilled()) {
      const {intl} = this.props;
      renderErrorPopup(intl.formatMessage({id: "contractSign.errorSignaturePopupMessage"}), "", this.postContractSignature.bind(this));
      return;
    }
    const pngBase64 = this.sigCanvas.getTrimmedCanvas().toDataURL('image/png');
    const { signaturePadTag, contractsList, activeContract, contractsValues } = this.props;
    const { pageIndex, fieldIndex, fieldName, isReceiptSign, signatureName } = signaturePadTag;

    if (activeContract) {
      this.props.setContractsValues({
        contractId: activeContract.id,
        pageIndex,
        fieldIndex,
        name: fieldName,
        value: pngBase64,
      });
      if (signatureName) { // update existing values with the same sign
        const selectedContracts = getSelectedContracts(contractsList);
        const withoutRequiredSignatureName = getFieldNameWithoutRequired(signatureName);
        for (const contract of selectedContracts) {
          let {fields} = contract;
          fields.forEach(field => {
            if (!field.isEditable || !field.isSignature) {
              return;
            }
            field.coords.forEach((coord) => {
              if (!coord.fieldName) {
                return;
              }
              const compareName = getFieldNameWithoutRequired(coord.fieldName);
              if ((contract.id === activeContract.id && coord.fieldIndexOnPage === fieldIndex && coord.page === pageIndex)
                // we already did it
                || (compareName !== withoutRequiredSignatureName) || (compareName === "<$signature>")) {
                // only signature1, signature2 should match
                return
              }
              const signatureValue = getFieldValue(coord.page, coord.fieldIndexOnPage, contract, contractsValues);
              if (signatureValue) {
                this.props.setContractsValues({
                  contractId: contract.id,
                  pageIndex: coord.page,
                  fieldIndex: coord.fieldIndexOnPage,
                  name: field.name,
                  value: pngBase64,
                });
              }
            })
          })
        }
      }
    } else if (isReceiptSign) {
      this.props.setReceiptSignature(pngBase64);
    }

    this.props.showSignaturePad(false, null);
  }

  closeContractSigning = step => {
    if (step === 3) {
      Analytics.sendClickEvent("contract-signed-ok");
      this.props.showContractSigning(false);
      this.props.contractSigningCallback();
    } else {
      this.props.showSignaturePad(false);
    }
  }

  render() {
    return (
      <div className="overlay overlay--contract-popup">
        <div className="contract-popup">
          <Fragment>
            <div className="contract-popup__header">
              {/*<div className="secondary"><span className="red">*</span> <FormattedMessage id="contractSign.requiredFieldsNotice"/></div>*/}
              <div className="contract-popup__header-title"><FormattedMessage id="contractSign.requiredFieldsNoticeText"/></div>
            </div>
            <div className="contract-popup__body">
              <div className="contract-popup__body-sign">
                <SignatureCanvas canvasProps={{className: 'contract-popup__body-sign-canvas'}}
                                 ref={ref => this.sigCanvas = ref}>
                </SignatureCanvas>
              </div>
            </div>
            <div className="contract-popup__footer">
              <div className="ui-popup__footer-left/"/>
              <div className="ui-popup__footer-right">
                <button className="ui-button2 ui-button2--blue ui-button3--wide" onClick={() => this.sigCanvas.clear()}>
                  <FormattedMessage id="contractSign.footerClearButton"/>
                </button>
                <button className="ui-button2 ui-button2--green ui-button3--wide"
                        onClick={this.postContractSignature}>
                  <FormattedMessage id="contractSign.footerSignButton"/>
                </button>
              </div>
            </div>
          </Fragment>
          <button className="ui-close contract-popup__close" onClick={() => this.closeContractSigning(-1)}/>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const {userState, contractSigningState} = state;
  const {receiptSignature} = state.printState;
  return {
    customerEmail: userState.userInfo.email,
    step: contractSigningState.step,
    contractSigningCallback: contractSigningState.callback,
    signaturePadTag: contractSigningState.signaturePadTag,
    contractsList: contractSigningState.contractsList,
    contractsValues: contractSigningState.contractsValues,
    receiptSignature,
  }
};

const mapDispatchToProps = {
  showContractSigning,
  showSignaturePad,
  setContractsValues,
  setContractsList,
  setReceiptSignature,
};

SignaturePadPopup.propTypes = {
  activeContract: PropTypes.object,
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SignaturePadPopup)
)
